import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { TotalAssetsValue } from '@/entities/leaderboard/ui/totalAssetsValue'
import { Tab } from '@/shared/ui/appTabs'
import { LeaderboardTabs } from '@/entities/leaderboard/ui/leaderboardTabs'

import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { AppAvatar } from '@/shared/ui/appAvatar'
import { Skeleton } from '@mui/material'

export const LeaderboardSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.leaderboard
  const imgs = [
    'https://storage.yandexcloud.net/gamed/stuff/leaderboardSecond.webp',
    'https://storage.yandexcloud.net/gamed/stuff/leaderboardFirst.webp',
    'https://storage.yandexcloud.net/gamed/stuff/leaderboardThird.webp',
  ]
  const tabs: Tab[] = [
    { label: texts.tabs.gigi, icon: 'gigi', value: 0 },
    { label: texts.tabs.gamed, icon: 'gamed', value: 1 },
    { label: texts.tabs.assets, icon: 'leaderboardAssets', value: 2 },
    { label: texts.tabs.hours, icon: 'leaderboardTime', value: 3 },
  ]

  return (
    <div className={classes.root}>
      <div className={classes.tvgaAndTabsWrapper}>
        <span className={classes.title}>{texts.leaderboard}</span>
        <TotalAssetsValue amount={' ??? ??? ???'} />
      </div>
      <LeaderboardTabs tabs={tabs} activeValue={0} onChange={() => {}} />
      <div className={classes.topUserseRoot}>
        {imgs.map((img, index) => (
          <div className={classes.userContainerWrapper} style={{ width: index === 1 ? '40%' : '30%' }}>
            <div className={classes.avatarWrapper}>
              <AppAvatar width={48} src={''} subscriptionLevel={0} />
              <div className={classes.nameWrapper}>
                <span style={{ minHeight: '4px' }}>{'           '}</span>
              </div>
            </div>
            <img src={img} alt="" width={'100%'} />
            <div className={classes.gigiWrapper} style={{ top: '94px' }}>
              <span>{'?? ???'}</span>
              {/* <span style={{ color: '#fff' }}>{unit}</span> */}
            </div>
          </div>
        ))}
      </div>
      <div className={classes.stickyHeaderWrapper}>
        <div className={classes.header}>
          <div className={classes.placeTittle}>#</div>
          <div className={classes.nameTittle}>{texts.name}</div>
          <div className={classes.variant}>{texts.units.gigi}</div>
        </div>
        <BackgroundShading left="0%" bottom="-26px" height="26px" upsideDown />
      </div>
      <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '12px' }}>
        {Array.from({ length: 8 }).map(() => (
          <Skeleton variant="rounded" width={'100%'} height={68} style={{ borderRadius: '12px' }} />
        ))}
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: '108px',
          width: '95%',
          zIndex: 1000,
          backgroundColor: '#1D1E22',
          borderRadius: '12px',
        }}
      >
        <Skeleton variant="rounded" width={'100%'} height={68} style={{ borderRadius: '12px' }} />
      </div>
    </div>
  )
}
